import React from 'react';
import Card from './Card';
import Button from './Button';

interface OptionCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonText: React.ReactNode;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
}

const OptionCard: React.FC<OptionCardProps> = ({
  icon,
  title,
  description,
  buttonText,
  onClick,
  selected = false,
  disabled = false,
}) => {
  return (
    <Card 
      className={`p-6 flex flex-col h-full ${disabled ? 'bg-gray-50 opacity-70' : ''}`}
      selected={selected}
      hoverable={!disabled}
    >
      <div className={`mb-4 text-3xl ${disabled ? 'text-gray-400' : 'text-blue-600'}`}>{icon}</div>
      <h3 className={`text-xl font-semibold mb-2 ${disabled ? 'text-gray-400' : 'text-gray-900'}`}>{title}</h3>
      <p className={`mb-6 flex-grow ${disabled ? 'text-gray-400' : 'text-gray-600'}`}>{description}</p>
      <div className="mt-auto">
        <Button 
          variant="primary" 
          onClick={disabled ? undefined : onClick} 
          withArrow={!disabled}
          fullWidth={true}
          disabled={disabled}
        >
          {buttonText}
        </Button>
      </div>
    </Card>
  );
};

export default OptionCard;